
export const PUBLIC_URL = "https://api.qingwaai.com/qhjUMallA/admin/";

// export const PUBLIC_URL = "http://127.0.0.1:8728//qhjUMallA/admin/"; //测试

export const ERR_OK = 200;

export const ERR_POST = "主管";

export const ERR_BOSS = "CEO";



// WEBPACK FOOTER //
// ./src/api/config.js